module.exports = __webpack_public_path__ + "static/week_week6_spot5-d45caf41738ea6bcf681d5de2552b978.jpg";